import { useEffect } from 'react'
import {
  FormContent,
  FormContentBody,
  FormContentHeadings,
  QuestionSubtext,
  QuestionSupertext,
} from 'src/consumer/components/Form/FormStyles'
import { MultiSelectComponentITS } from 'src/consumer/components/Form/helpers/componentRenderingHelper'
import { ADDICTION_TYPES_OPTIONS } from '../../utils'

export default function AddictionSelection({ formData, setFormData, goToNextPage }) {
  function setAddictionType(value) {
    setFormData((prev) => {
      nextPage([...(prev?.addictionTypes || []), ...(value || [])])

      return {
        ...prev,
        addictionTypes: value,
      }
    })
  }

  function nextPage(allAddictionTypes) {
    goToNextPage(allAddictionTypes?.[allAddictionTypes?.length - 1])
  }

  useEffect(() => {
    setFormData((prev) => ({ ...prev, addictionTypes: [] }))
  }, [])

  return (
    <>
      <FormContent>
        <FormContentHeadings>
          <QuestionSupertext>Choose your addiction type</QuestionSupertext>
          <QuestionSubtext>
            We have a variety of addiction types to choose from. Please select the type of addiction
            you are facing.
          </QuestionSubtext>
        </FormContentHeadings>
        <FormContentBody>
          <MultiSelectComponentITS
            data={formData?.addictionTypes}
            setDataFunction={setAddictionType}
            options={ADDICTION_TYPES_OPTIONS}
          />
        </FormContentBody>
      </FormContent>
    </>
  )
}

/* <SingleSelectComponentITSOET
            data={formData?.addictionTypes}
            setDataFunction={setAddictionType}
            onSubmitFunction={nextPage}
            options={addictionOptions}
          /> */
